import React, { Fragment } from "react";
import ScrollToTop from "react-scroll-to-top";
const AppalScrollToTop = () => {
  return (
    <Fragment>
      <ScrollToTop id="backtotop" smooth color="#fff" />
    </Fragment>
  );
};

export default AppalScrollToTop;
